import React, { Suspense } from 'react';
import { useLocation } from 'react-router';
import { Box, Paper } from '@mui/material';

import { PermissionedView } from '@cvt/components/Permissioned';
import { ListLoading } from '@cvt/components/layout/ListLoading';

import { PaginatedUniversityList } from '@modules/Universities/partials/PaginatedUniveristyList';
import { useNextAssertion } from '@modules/Assertions/hooks/useNextAssertion';
import { NoAssertions } from '@pages/Assertions/NoAssertions';
import { UniversityCard } from '../components/UniversityCard';
import { UniversityRow, UniversityRowSkeleton } from '../components/UniversityRowWithOptions';


interface ViewProps {
}

export const Universities: React.FC<ViewProps> = () => {

  const location = useLocation();
  const { next } = useNextAssertion();
  const [dismissNoAssertions, setDismissNoAssertions] = React.useState(false);
  const shouldShowNoAssertions =
        !dismissNoAssertions && ((next?.totalAnswered ?? 0) <=20);
  return (
    <PermissionedView permission="universities.list">
      <Suspense key={location.key} fallback={(
        <Box px={2}>
          <Paper
            variant="elevation"
            elevation={1}
            sx={{ overflow: 'hidden' }}
          >
            <ListLoading
              disablePadding
              repeat={10}
              renderItem={() => <UniversityRowSkeleton/>}
            />
          </Paper>
        </Box>
      )}>
        {shouldShowNoAssertions ? (
          <Box px={2}>
            <NoAssertions
              objectKey="universities"
              onSeeList={() => setDismissNoAssertions(true)}
            />
          </Box>

        )
          :
          (
            <PaginatedUniversityList
              renderCardItem={university => (
                <Box height="100%" pb={2}>
                  <UniversityCard key={university.id} {...university} />
                </Box>
              )}
              renderListItem={university => <UniversityRow key={university.id} {...university} />}
              renderSkeleton={() => <UniversityRowSkeleton/>}
            />
          )}

      </Suspense>
    </PermissionedView>
  );
};
